module.exports = __webpack_public_path__ + "resources/img/img_alyac3_m.f3d35a03b93f4d86a47e094b91ca8a6b.png";